/*
 * Proprietary and Confidential
 *
 * Copyright (c) [2018] -  [] Marcelo H. Krebber - Munich, London 2018
 * All Rights Reserved.
 *
 * Dissemination or reproduction of this file [sidebar-entry-date.js] or parts within
 * via any medium is strictly forbidden unless prior written permission is obtained
 * from <marcelo.krebber@gmail.com>
 *
 * Last modified: 13.02.20, 11:50
 */

import React from 'react';
import {Link} from 'react-router-dom';
import {ImageBoxBig} from "../../components/boxes/image-box-big";
import {DateTimeBoxSimple} from "../../components/boxes/date-boxes/date-time-box-long";
import {useLanguage} from "../../components/configuration/configuration";
import {
    CancelIcon,
    fs_smaller,
    HealthAndSafetyIcon,
    LocalAtmIcon,
    MaskSolidIcon
} from "../../components/navigation/icons/nav-icons";
import {cn} from "../../components/util/text-utils";
import {MarkDownText} from "../../components/toggler/markdown-text-toggler";
import SpaceAccessIcon from "../../components/navigation/icons/space-access-icon";
import {MembershipIconShort} from "../../components/navigation/icons/membership-icon";
import {TooltipIcon} from "../../components/navigation/buttons/nav-buttons";

/**
 *  basic information about the event including image for slider
 */
const CalendarEntry = ({peekspace, overlay = false, className}) => {
    const Lang = useLanguage();
    const calendarDate = peekspace.calendarDate;
    const calendarDateEnd = peekspace.calendarDateEnd;
    const activeSpace = `/${peekspace.username}/space/${peekspace.id}`;
    const isBlocked = peekspace.state === 'BLOCKED';
    const image = peekspace.url;
    const isBillable = peekspace.fees !== 'NONE';
    const isHygiene = peekspace.hygiene !== 'NONE';
    const isPrivate = peekspace.access === 'PRIVATE';
    const isCancelled = peekspace.state === 'CANCELLED';
    const isToday = peekspace.today;

    if(peekspace.type !== 'EVENT') return null;

    return <div className={cn('sidebar-entry-event shadow mt-1 mb-2', [className])}>
        <Link to={activeSpace}>
            <ImageBoxBig blocked={isBlocked || isCancelled} image={image}
                         overlay={overlay}
                         isToday={isToday}
                         category={peekspace.category}
                         text={peekspace.name}/>
        </Link>

        <div className='px-1 pb-1'>
            {/*{isCancelled &&*/}
            {/*    <div className='badge bg-danger rounded-pill small mt-1'>*/}
            {/*        {Lang.info.status.cancelledShort}*/}
            {/*    </div>}*/}

            <DateTimeBoxSimple
                date={calendarDate.date}
                startTime={calendarDate.startTime}
                endTime={calendarDate.endTime}
                className={cn('mt-2', [!calendarDateEnd, 'mb-1'])}/>

            {calendarDateEnd && <DateTimeBoxSimple
                date={calendarDateEnd.date}
                startTime={calendarDateEnd.startTime}
                endTime={calendarDateEnd.endTime}
                isEndDate={true}
                className='mb-1'/>}

            <div className="d-flex justify-content-between align-items-center">
                <div className='sidebar-space-text lh-1'>{peekspace.name}</div>
                <div className="d-flex align-items-right align-items-center">
                    {isPrivate &&<TooltipIcon title={Lang.info.access.privateShort}>
                        <MaskSolidIcon className="font-1x"/>
                    </TooltipIcon>}
                    <MembershipIconShort membership={peekspace.membership}/>
                    <SpaceAccessIcon access={peekspace.access}/>
                </div>
            </div>
            <div className='lh-125 mb-1'><MarkDownText text={peekspace.description}/></div>

            <div>
                <div className='box-aligned sidebar-space-title'>
                    <LocalAtmIcon size={fs_smaller} className="mr-1"/><span>{Lang.info.fees.text}</span>
                </div>
                <div className='text-smaller'>
                    <MarkDownText text={peekspace.feesDescription}/>
                </div>
                <div className='box-aligned sidebar-space-title'>
                    <HealthAndSafetyIcon size={fs_smaller} className="mr-1"/><span>{Lang.info.hygiene.text}</span>
                </div>
                {isCancelled && <div className='box-aligned font--80x'>
                    <CancelIcon size={fs_smaller} className="clr-red"/> <span className="ml-1">{Lang.info.status.cancelled}</span>
                </div>}

                <div className='text-smaller'>
                    <MarkDownText text={peekspace.hygieneDescription}/>
                </div>
            </div>
        </div>
    </div>
}

export default CalendarEntry;